const ICON_PATHS = {
  graduation: 'M4.26 10.147a60.436 60.436 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443',
  language: 'M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m6.334-12.138a48.436 48.436 0 0 1 5.291 3.264M9 5.25a48.436 48.436 0 0 0-2.666.114m0 0A5.984 5.984 0 0 0 3 9c0 1.4.5 2.68 1.334 3.678',
  clock: 'M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  sparkle: 'M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z',
}

function CredentialIcon({ name }) {
  return (
    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path strokeLinecap="round" strokeLinejoin="round" d={ICON_PATHS[name]} />
    </svg>
  )
}

export default function AstrologerAboutSection({ astro }) {
  const specialties = astro.skills.length ? astro.skills.join(', ') : 'Vedic astrology'

  const credentials = [
    {
      icon: 'graduation',
      title: `${astro.experience}+ years in practice`,
      subtitle: 'Classical Vedic astrology training',
    },
    {
      icon: 'sparkle',
      title: astro.skills[0] ? `Specialises in ${astro.skills[0]}` : 'Vedic astrology specialist',
      subtitle: astro.skills.length > 1 ? `Also covers ${astro.skills.slice(1).join(', ')}` : 'Personalised chart-based guidance',
    },
    {
      icon: 'language',
      title: astro.languages.length ? astro.languages.join(', ') : 'Hindi, English',
      subtitle: 'Consultations in your language',
    },
    {
      icon: 'clock',
      title: `${astro.duration} min sessions`,
      subtitle: 'Live video or audio call',
    },
  ]

  return (
    <div className="info-card p-6 sm:p-8 space-y-5">
      <h2 className="text-xl font-cinzel text-[#1C140A]">About {astro.name}</h2>
      <p className="text-sm leading-relaxed text-[#5C3A18]">
        {astro.name} is a Vedic astrologer with {astro.experience}+ years of experience, focused on {specialties.toLowerCase()}.
        Sessions are built around a detailed reading of your birth chart, translated into clear, practical guidance for the
        questions that matter to you — rather than generic, one-size-fits-all predictions.
      </p>
      <div className="grid gap-4 sm:grid-cols-2">
        {credentials.map((c) => (
          <div key={c.title} className="flex items-start gap-3">
            <span className="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary/10 text-secondary">
              <CredentialIcon name={c.icon} />
            </span>
            <div>
              <p className="text-sm font-semibold text-[#1C140A]">{c.title}</p>
              <p className="text-xs text-[#8B7355] mt-0.5">{c.subtitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
